/* tslint:disable */
import {
  ProductionOrder,
  Product,
  ProductUom,
  ProductUomCategory,
  StockLocation,
  StockQuantPackage,
  StockProductionLot,
  Company,
  StockMove
} from '../index';

declare var Object: any;
export interface ProductionOrderOutLineInterface {
  "id"?: number;
  "production_order_id"?: number;
  "product_id"?: number;
  "auto_assign_pack"?: boolean;
  "product_uom_id"?: number;
  "product_uom_category_id"?: number;
  "product_qty"?: number;
  "location_id"?: number;
  "package_id"?: number;
  "prod_lot_id"?: number;
  "company_id"?: number;
  "real_qty"?: number;
  "move_id"?: number;
  "date_done"?: Date;
  "state"?: string;
  "prod_lot_name"?: string;
  "package_name"?: string;
  "pore"?: boolean;
  "colour"?: string;
  "correct_form"?: boolean;
  "humidity"?: boolean;
  "quality_comment"?: string;
  "initial_pressure_filter_1"?: number;
  "final_pressure_filter_1"?: number;
  "initial_pressure_filter_2"?: number;
  "final_pressure_filter_2"?: number;
  "filter_size"?: number;
  "final_state"?: string;
  "package_regrowth"?: boolean;
  "package_shredded"?: boolean;
  "pile_used"?: boolean;
  "carbonate_percentage"?: number;
  "comment"?: string;
  "production_order_out_ids"?: number;
  productionOrder?: ProductionOrder;
  product?: Product;
  productUom?: ProductUom;
  productUomCategory?: ProductUomCategory;
  location?: StockLocation;
  package?: StockQuantPackage;
  prodLot?: StockProductionLot;
  company?: Company;
  move?: StockMove;
}

export class ProductionOrderOutLine implements ProductionOrderOutLineInterface {
  "id": number;
  "production_order_id": number;
  "product_id": number;
  "auto_assign_pack": boolean;
  "product_uom_id": number;
  "product_uom_category_id": number;
  "product_qty": number;
  "location_id": number;
  "package_id": number;
  "prod_lot_id": number;
  "company_id": number;
  "real_qty": number;
  "move_id": number;
  "date_done": Date;
  "state": string;
  "prod_lot_name": string;
  "package_name": string;
  "pore": boolean;
  "colour": string;
  "correct_form": boolean;
  "humidity": boolean;
  "quality_comment": string;
  "initial_pressure_filter_1": number;
  "final_pressure_filter_1": number;
  "initial_pressure_filter_2": number;
  "final_pressure_filter_2": number;
  "filter_size": number;
  "final_state": string;
  "package_regrowth": boolean;
  "package_shredded": boolean;
  "pile_used": boolean;
  "carbonate_percentage": number;
  "comment": string;
  "production_order_out_ids": number;
  productionOrder: ProductionOrder;
  product: Product;
  productUom: ProductUom;
  productUomCategory: ProductUomCategory;
  location: StockLocation;
  package: StockQuantPackage;
  prodLot: StockProductionLot;
  company: Company;
  move: StockMove;
  constructor(data?: ProductionOrderOutLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductionOrderOutLine`.
   */
  public static getModelName() {
    return "ProductionOrderOutLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductionOrderOutLine for dynamic purposes.
  **/
  public static factory(data: ProductionOrderOutLineInterface): ProductionOrderOutLine{
    return new ProductionOrderOutLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductionOrderOutLine',
      plural: 'ProductionOrderOutLines',
      path: 'ProductionOrderOutLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "production_order_id": {
          name: 'production_order_id',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "auto_assign_pack": {
          name: 'auto_assign_pack',
          type: 'boolean'
        },
        "product_uom_id": {
          name: 'product_uom_id',
          type: 'number'
        },
        "product_uom_category_id": {
          name: 'product_uom_category_id',
          type: 'number'
        },
        "product_qty": {
          name: 'product_qty',
          type: 'number'
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "package_id": {
          name: 'package_id',
          type: 'number'
        },
        "prod_lot_id": {
          name: 'prod_lot_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "real_qty": {
          name: 'real_qty',
          type: 'number'
        },
        "move_id": {
          name: 'move_id',
          type: 'number'
        },
        "date_done": {
          name: 'date_done',
          type: 'Date'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "prod_lot_name": {
          name: 'prod_lot_name',
          type: 'string'
        },
        "package_name": {
          name: 'package_name',
          type: 'string'
        },
        "pore": {
          name: 'pore',
          type: 'boolean'
        },
        "colour": {
          name: 'colour',
          type: 'string'
        },
        "correct_form": {
          name: 'correct_form',
          type: 'boolean'
        },
        "humidity": {
          name: 'humidity',
          type: 'boolean'
        },
        "quality_comment": {
          name: 'quality_comment',
          type: 'string'
        },
        "initial_pressure_filter_1": {
          name: 'initial_pressure_filter_1',
          type: 'number'
        },
        "final_pressure_filter_1": {
          name: 'final_pressure_filter_1',
          type: 'number'
        },
        "initial_pressure_filter_2": {
          name: 'initial_pressure_filter_2',
          type: 'number'
        },
        "final_pressure_filter_2": {
          name: 'final_pressure_filter_2',
          type: 'number'
        },
        "filter_size": {
          name: 'filter_size',
          type: 'number'
        },
        "final_state": {
          name: 'final_state',
          type: 'string'
        },
        "package_regrowth": {
          name: 'package_regrowth',
          type: 'boolean'
        },
        "package_shredded": {
          name: 'package_shredded',
          type: 'boolean'
        },
        "pile_used": {
          name: 'pile_used',
          type: 'boolean'
        },
        "carbonate_percentage": {
          name: 'carbonate_percentage',
          type: 'number'
        },
        "comment": {
          name: 'comment',
          type: 'string'
        },
        "production_order_out_ids": {
          name: 'production_order_out_ids',
          type: 'number'
        },
      },
      relations: {
        productionOrder: {
          name: 'productionOrder',
          type: 'ProductionOrder',
          model: 'ProductionOrder',
          relationType: 'belongsTo',
                  keyFrom: 'production_order_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        productUom: {
          name: 'productUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_id',
          keyTo: 'id'
        },
        productUomCategory: {
          name: 'productUomCategory',
          type: 'ProductUomCategory',
          model: 'ProductUomCategory',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_category_id',
          keyTo: 'id'
        },
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        package: {
          name: 'package',
          type: 'StockQuantPackage',
          model: 'StockQuantPackage',
          relationType: 'belongsTo',
                  keyFrom: 'package_id',
          keyTo: 'id'
        },
        prodLot: {
          name: 'prodLot',
          type: 'StockProductionLot',
          model: 'StockProductionLot',
          relationType: 'belongsTo',
                  keyFrom: 'prod_lot_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        move: {
          name: 'move',
          type: 'StockMove',
          model: 'StockMove',
          relationType: 'belongsTo',
                  keyFrom: 'move_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductionOrderOutLine.ts